import React, { useEffect, useState } from 'react';
import { api } from './AdminApp';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api('/admin/leads/stats')
      .then((d) => setStats(d.stats))
      .catch((e) => setError(e.message));
  }, []);

  const cards = stats
    ? [
        ['Appointments', stats.appointments, '#e8f0fe', '#1a56db'],
        ['Contact Messages', stats.contacts, '#e6f4ea', '#137333'],
        ['Job Applications', stats.jobs, '#fef7e0', '#b45309'],
        ['Subscribers', stats.subscribers, '#f3e8fd', '#6b21a8'],
      ]
    : [];

  return (
    <div>
      <h1 className="admin-page-title">Dashboard</h1>
      {error && <div className="admin-alert admin-alert-error">{error}</div>}
      <div className="admin-stats-grid">
        {cards.map(([label, value, bg, fg]) => (
          <div key={label} className="admin-stat-card" style={{ background: bg, color: fg }}>
            <div className="admin-stat-value">{value}</div>
            <div className="admin-stat-label">{label}</div>
          </div>
        ))}
      </div>

      <div className="admin-card">
        <h2>Quick actions</h2>
        <p className="admin-muted">
          Manage what visitors see: doctors, services and blog posts are served live from the
          database to the public site.
        </p>
      </div>
    </div>
  );
}
